jQuery(document).ready(function () {

    var $searchRecipesForm = $("form.search--form");

    $(".recipe-results .pt--filter-selected button").click(function () {
        var c = $(this).attr("data-categoryguid");
        $searchRecipesForm.find('input[name="categories"][value="' + c + '"]').remove();
        $(this).parent().remove();
        $searchRecipesForm.data("bypass-validation", true).submit();
    });

    var keyword = $searchRecipesForm.find('input[name=keywords]').val();
    keyword = (keyword ? keyword.trim() : '');

    var searchCategory = 'recette';
    if ($('.recipe-results .alert--error').length) {
        searchCategory += '|sansresultat';
    }
});